import { useEffect } from 'react';
import { toast } from 'react-toastify';
import isPathVisitedByAllowedBrowser from '../browserDetection/isPathVisitedByAllowedBrowser';

function useDisplayForbiddenBrowserNotification(history) {
  useEffect(() => {
    let isNotificationDisplayed = false;
    const showNotification = () => {
      const notificationMessage =
        'Для стабильной работы нашей платформы рекомендуем использовать Яндекс Браузер.';
      if (!isNotificationDisplayed) {
        toast.warning(notificationMessage, {
          position: 'top-right',
          hideProgressBar: false,
          autoClose: 10000,
          theme: 'light',
        });
        isNotificationDisplayed = true;
      }
    };
    console.log(!isPathVisitedByAllowedBrowser(history.location))
    if (!isPathVisitedByAllowedBrowser(history.location)) {
      showNotification();
    }
    return history.listen(location => {
      if (!isPathVisitedByAllowedBrowser(location)) {
        showNotification();
      }
    });
  }, []);
}

export default useDisplayForbiddenBrowserNotification;
